@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/address-cards-1x3/stiiizy-address-card-stack-content/stiiizy-address-product-information/stiiizy-address-product-information.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
.stiiizy-wide-product-information {
  position: relative;
  flex: 1;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0.3125rem;
  display: flex;
  flex-direction: row;
  gap: 0.3125rem;
  --badge-grid-min-col: 1rem;
}
.stiiizy-wide-product-information .background-content {
  position: absolute;
  inset: 0;
  z-index: -1;
}
.stiiizy-wide-product-information .logo-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.stiiizy-wide-product-information .logo-container .brand-logo {
  width: 6rem;
}
.stiiizy-wide-product-information .logo-container .product-card-brand {
  font-family: Archivo, sans-serif;
  font-weight: 900;
  font-size: 0.9375rem;
  width: 6rem;
  text-align: center;
}
.stiiizy-wide-product-information .product-info-container {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.125rem;
}
.stiiizy-wide-product-information .product-info-container .product-card-variant-title {
  font-family: Archivo, sans-serif;
  font-weight: 900;
  font-size: 0.875rem;
  letter-spacing: -0.42px;
  text-transform: uppercase;
  text-align: center;
}
.stiiizy-wide-product-information .product-info-container .cannabinoids {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 0.25rem;
  row-gap: 0.125rem;
}
.stiiizy-wide-product-information .product-info-container .cannabinoids .product-cannabinoid {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: max-content;
  column-gap: 0.125rem;
  text-transform: uppercase;
  font-family: Archivo, sans-serif;
  font-weight: 700;
  font-size: 0.5625rem;
  line-height: 100%;
  letter-spacing: -0.21px;
}
.stiiizy-wide-product-information .product-info-container .cannabinoids .product-cannabinoid span {
  font-family: Archivo, sans-serif;
  font-weight: 900;
}
.stiiizy-wide-product-information .product-info-container .size-and-label {
  flex-direction: row;
  display: flex;
  align-items: center;
  gap: 0.3125rem;
  font-family: Archivo, sans-serif;
  font-weight: 700;
  font-size: 0.5625rem;
}
.stiiizy-wide-product-information .product-info-container .size-and-label .product-card-size {
  width: max-content;
  white-space: nowrap;
}
.stiiizy-wide-product-information .product-info-container .size-and-label ::ng-deep .product-label {
  font-family: Archivo, sans-serif;
  font-weight: 700;
  font-size: 0.375rem;
  margin-left: 0;
  padding: 0.125rem 0.1875rem;
  border-radius: 0.125rem;
}
.stiiizy-wide-product-information .product-info-container .bottom-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
}
.stiiizy-wide-product-information .product-info-container .bottom-content .product-card-price {
  position: relative;
}
.stiiizy-wide-product-information .product-info-container .bottom-content .product-card-price .badge-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translate(calc(-100% - 0.6875rem), 0);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.1875rem;
  justify-content: center;
  align-items: center;
}
.stiiizy-wide-product-information .product-info-container .bottom-content .product-card-price .badge-container .badge {
  height: 1rem;
}
.stiiizy-wide-product-information .product-info-container .bottom-content .product-card-price ::ng-deep .product-variant-price {
  position: relative;
  font-family: Archivo, sans-serif;
  font-weight: 900;
  font-size: 1.125rem;
  letter-spacing: -0.54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.3125rem;
  line-height: 100%;
  overflow: visible;
}
.stiiizy-wide-product-information .product-info-container .bottom-content .product-card-price ::ng-deep .product-variant-price .product-variant-previous-price {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(calc(100% + 0.5rem), 50%);
  font-family: Archivo, sans-serif;
  font-weight: 900;
  font-size: 0.5625rem;
  letter-spacing: -0.27px;
  opacity: 0.5;
  line-height: 100%;
  overflow: visible;
}
.stiiizy-wide-product-information ::ng-deep .product-column-general {
  overflow-x: visible !important;
}
.stiiizy-wide-product-information ::ng-deep .force-italic-style * {
  font-style: italic !important;
}
/*# sourceMappingURL=stiiizy-address-product-information.component.css.map */
